import React from 'react';
import { Footer } from '../components/HomePage';
import HowItWorksHeader from '../components/HowItWorks/HowItWorksHeader';
import AboutUs from '../components/AboutUs/AboutUs';

function AboutUsPage() {
  return (
    <>
      <HowItWorksHeader />
      <AboutUs />
      <Footer />
    </>
  );
}

export default AboutUsPage;